import React from 'react';
import { GameTitleProps } from '../types';
import './GameTitle.css';

const GameTitle: React.FC<GameTitleProps> = (props) => {
  const { 
    title = "VŨ TRỤ KILOBA",
    onBackClick,
    onInfoClick 
  } = props;
  return (
    <div className="game-title-container" data-name="Game_Title">
      {/* <button 
        className="game-title-btn game-title-btn-back" 
        onClick={onBackClick}
        data-name="Button/Back"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button> */}
      
      <h1 className="game-title-text">
        {title}
      </h1>
      
      {/* <button 
        className="game-title-btn game-title-btn-info" 
        onClick={onInfoClick}
        data-name="Button/Information"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
          <path d="M12 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button> */}
    </div>
  );
};

export default GameTitle;
